// App-wide configuration — single source of truth for env values and defaults

const configuredApiBase = process.env.REACT_APP_API_BASE_URL?.trim();

// Keep the base URL free of a trailing slash so endpoint composition cannot
// accidentally produce `//api/...`. An empty value intentionally means the
// current origin, which is required when the app is served behind a proxy.
export const API_BASE = configuredApiBase
  ? configuredApiBase.replace(/\/+$/, '')
  : '';

export const STORAGE_KEYS = {
  auth: 'ism.auth.v1',
  tweaks: 'ism.tweaks.v1',
  notiEnabled: 'ism.noti.enabled',
  exportColumns: 'ism.export.columns.v1',
};

export const TWEAK_DEFAULTS = {
  accent: '#4f46e5',
  density: 'regular',
  dark: false,
  showHeatmap: true,
};

export const FALLBACK_TZ = 'Asia/Tokyo';
